import * as Yup from 'yup';

export const planFormSchema = Yup.object().shape({
  // customer: Yup.object()
  //   .shape({
  //     customerID: Yup.string()
  //       .nullable()
  //       .required('Customer is required')
  //       .test('not-zero', 'Customer is required', (value) => value !== '' && value !== '0'),
  //   })
  //   .required('Customer is required'),
  // office: Yup.object()
  //   .shape({
  //     customerID: Yup.string()
  //       .nullable()
  //       .required('Office is required')
  //       .test('not-zero', 'Office is required', (value) => value !== '' && value !== '0'),
  //   })
  //   .nullable()
  //   .required('Office is required'),
  planName: Yup.string().required('Print (or file) name is required'),
  // planFileTypeID: Yup.string().required('File type is required'),
  // bluePrint: Yup.string().required('Blueprint is required'),
  // uploadedFile: Yup.mixed().when('extension', {
  //   is: (extension: any) => !!extension, // If an extension is selected
  //   then: (schema) => schema.required('File upload is required'),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
});
